import {
  QuickPassSharePage,
  QuickPassSharePageVisibility,
} from '../_types/quickpass-share-page'

const defaultQuickPassSharePageVisibility: QuickPassSharePageVisibility = {
  showContact: true,
  showPreferences: true,
  showAboutMe: true,
  showSavedCount: true,
  showMoveInDate: true,
  showIncome: false,
  showAuthProviders: true,
  showVerifications: true,
}

const defaultQuickPassSharePage: QuickPassSharePage = {
  id: '',
  quickPassUserId: '',
  slug: '',
  shareToken: '',
  isActive: true,
  visibility: defaultQuickPassSharePageVisibility,
  headline: '',
  customMessage: '',
  viewCount: 0,
  lastViewedAt: null,
  createdAt: 0,
  updatedAt: 0,
}

export { defaultQuickPassSharePageVisibility, defaultQuickPassSharePage }
